import React from "react";
import ButtonsSection from "components/ui/buttons/ButtonsSection";
import "./Trends.module.css";
import EmptyState from "components/EmptyState";
import CausesList from "./CausesList";
import MoodBalanceChart from "../../../shared/charts/moodBalance/MoodBalanceChart";
import { useTrendsView } from "../hooks/useTrendsView";
import { maxBarHeight } from "./constants";
import BarChart from "./BarChart";
import PeriodSelector from "./PeriodSelector";
import styles from "./Trends.module.css";

export default function Trends() {
  const {
    showCauses,
    setShowCauses,
    selectedCauseView,
    setSelectedCauseView,
    selectedPeriod,
    totalMoods,
    balancePieData,
    modifiedBalancePieData,
    burnoutCauses,
    balancedCauses,
    barChartData,
    weekdayLabels,
    availableWeeks,
    selectedWeek,
    onWeekChange,
    insightsGranularity,
    setInsightsGranularity,
    availableMonths,
    selectedMonth,
    onMonthChange,
  } = useTrendsView();

  return (
    <div className={styles["trends-page-container"]}>
      <div className={styles["content-container"]}>
        {
          <PeriodSelector
            insightsGranularity={insightsGranularity}
            setInsightsGranularity={setInsightsGranularity}
            availableWeeks={availableWeeks ?? []}
            selectedWeek={selectedWeek}
            onWeekChange={onWeekChange}
            availableMonths={availableMonths ?? []}
            selectedMonth={selectedMonth}
            onMonthChange={onMonthChange}
          />
        }

        {
          <div className={styles["button-group-container"]}>
            <button
              onClick={() => {
                setShowCauses(false);
                setSelectedCauseView("OVERVIEW");
              }}
              className={[
                styles["cause-view-button"],
                selectedCauseView === "OVERVIEW" &&
                  styles["cause-view-button-active"],
              ]
                .filter(Boolean)
                .join(" ")}
            >
              Overview
            </button>
            <button
              onClick={() => {
                setShowCauses(false);
                setSelectedCauseView("BALANCED");
              }}
              className={[
                styles["cause-view-button"],
                selectedCauseView === "BALANCED" &&
                  styles["cause-view-button-active"],
              ]
                .filter(Boolean)
                .join(" ")}
            >
              Balanced
            </button>

            <button
              onClick={() => {
                setShowCauses(true);
                setSelectedCauseView("BURNOUT");
              }}
              className={[
                styles["cause-view-button"],
                selectedCauseView === "BURNOUT" &&
                  styles["cause-view-button-active"],
              ]
                .filter(Boolean)
                .join(" ")}
            >
              Burnout
            </button>
          </div>
        }

        <div className={styles["challenged-heading-wrap"]}>
          <h2>Insights</h2>
        </div>

        <br />

        <h3>Feelings</h3>
        {showCauses ? (
          <>
            {totalMoods > 0 ? (
              <>
                <h2 className={styles["top-causes-title"]}>
                  Burned out feelings
                </h2>
                <MoodBalanceChart
                  balancePieData={modifiedBalancePieData}
                  totalMoods={totalMoods}
                />
              </>
            ) : (
              <>
                <EmptyState title="No mood data available" />
              </>
            )}

            {burnoutCauses ? Object.keys(burnoutCauses).length : 0}
            <CausesList filteredCauses={burnoutCauses} />
          </>
        ) : (
          <>
            {totalMoods > 0 ? (
              <>
                {selectedCauseView === "OVERVIEW" ? (
                  <>
                    <BarChart
                      barChartData={barChartData}
                      weekdayLabels={weekdayLabels}
                      maxBarHeight={maxBarHeight}
                    />
                  </>
                ) : (
                  <>
                    <h2 className={styles["top-causes-title"]}>
                      Balanced feelings
                    </h2>
                    <MoodBalanceChart
                      balancePieData={balancePieData}
                      totalMoods={totalMoods}
                    />
                  </>
                )}
              </>
            ) : (
              <>
                <EmptyState title="No mood data available" />
              </>
            )}
            <CausesList filteredCauses={balancedCauses} />
          </>
        )}
      </div>
      <div className="buttons-wrapper">
        <ButtonsSection />
      </div>
    </div>
  );
}
